import React from 'react';
import { RouteObject } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../util/PathUtil';
import { DeviceRoutes } from './DeviceRoutes';
import { QuestionnaireRoutes } from './QuestionnaireRoutes';
import { VisitRoutes } from './VisitRoutes';
import { ComplianceRoutes } from './ComplianceRoutes';
import { RpmRoutes } from './RpmRoutes';
import { PatientOverviewDrawerRoutes } from './PatientOverviewDrawerRoutes';

const lazyLoadPages: () => Promise<typeof import('./PatientNavPages')> = () =>
  import(/* webpackPrefetch: true */ './PatientNavPages');

const PatientNavPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientNavPage,
  })),
);

const PatientOverViewPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientOverviewPage,
  })),
);

const QuestionnairePage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.QuestionnairePage,
  })),
);

const PatientMedicationPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientMedicationPage,
  })),
);

const PatientBioSamplesPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientBioSamplesPage,
  })),
);

const PatientVisitsPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientVisitsPage,
  })),
);

const PatientCompliancePage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientCompliancePage,
  })),
);

const HealthEventNavPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.HealthEventNavPage,
  })),
);

const PatientListDefaultRoute = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientListDefaultRoute,
  })),
);

export const PatientNavRoutes: RouteObject[] = [
  {
    element: <PatientNavPage />,
    children: [
      // Patient Overview
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_OVERVIEW, true),
        element: <PatientOverViewPage />,
        children: PatientOverviewDrawerRoutes,
      },
      // Patient Questionnaires
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_QUESTIONNAIRE_LIST, true),
        element: <QuestionnairePage />,
        children: QuestionnaireRoutes,
      },
      ...DeviceRoutes,
      // Patient Medication
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_MEDICATION, true),
        element: <PatientMedicationPage />,
      },
      // Patient Samples
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_SAMPLES, true),
        element: <PatientBioSamplesPage />,
      },
      // Patient Visits
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_VISITS, true),
        element: <PatientVisitsPage />,
        children: VisitRoutes,
      },
      // Patient Compliance
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_COMPLIANCE, true),
        element: <PatientCompliancePage />,
        children: ComplianceRoutes,
      },
      // Patient Health Event
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_HEALTH_EVENT_VIEW, true),
        element: <HealthEventNavPage />,
      },
      // Patient Remote Monitoring
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_RPM, true),
        children: RpmRoutes,
      },
      {
        path: '*',
        element: <PatientListDefaultRoute />,
      },
    ],
  },
];
